import {
  AutocompleteFieldProps,
  OmitedTextFieldProps,
  OmitedAutocompleteProps,
} from "./AutocompleteField.types";

export function extractAutcompleteProps(
  props: AutocompleteFieldProps
): [OmitedAutocompleteProps, OmitedTextFieldProps] {
  const {
    autoComplete,
    autoHighlight,
    autoSelect,
    blurOnSelect,
    ChipProps,
    classes,
    clearOnBlur,
    clearOnEscape = true,
    clearText,
    closeIcon,
    closeText,
    defaultValue,
    disableClearable,
    disableCloseOnSelect,
    disabled,
    disabledItemsFocusable,
    disableListWrap,
    disablePortal,
    filterOptions,
    filterSelectedOptions,
    forcePopupIcon,
    freeSolo,
    fullWidth,
    getLimitTagsText,
    getOptionDisabled,
    getOptionLabel,
    getOptionSelected,
    groupBy,
    handleHomeEndKeys,
    id,
    includeInputInList,
    inputValue,
    limitTags,
    ListboxComponent,
    ListboxProps,
    loading,
    loadingText,
    multiple,
    noOptionsText,
    onChange,
    onClose,
    onHighlightChange,
    onInputChange,
    onOpen,
    open,
    openOnFocus,
    openText,
    options,
    PaperComponent,
    PopperComponent,
    popupIcon,
    renderGroup,
    renderOption,
    renderTags,
    selectOnFocus,
    size,
    value,
    ...other
  } = props;

  return [
    {
      autoComplete,
      autoHighlight,
      autoSelect,
      blurOnSelect,
      ChipProps,
      classes,
      clearOnBlur,
      clearOnEscape,
      clearText,
      clearIcon: closeIcon,
      closeText,
      defaultValue,
      disableClearable,
      disableCloseOnSelect,
      disabled,
      disabledItemsFocusable,
      disableListWrap,
      disablePortal,
      filterOptions,
      filterSelectedOptions,
      forcePopupIcon,
      freeSolo,
      fullWidth,
      getLimitTagsText,
      getOptionDisabled,
      getOptionLabel,
      isOptionEqualToValue: getOptionSelected,
      groupBy,
      handleHomeEndKeys,
      id,
      includeInputInList,
      inputValue,
      limitTags,
      ListboxComponent,
      ListboxProps,
      loading,
      loadingText,
      multiple,
      noOptionsText,
      onChange,
      onClose,
      onHighlightChange,
      onInputChange,
      onOpen,
      open,
      openOnFocus,
      openText,
      options,
      PaperComponent,
      PopperComponent,
      popupIcon,
      renderGroup,
      renderOption,
      renderTags,
      selectOnFocus,
      size,
      value,
    },
    { ...other },
  ];
}
